// Basemap toggle helper
function toggleBasemap(level, map, activeBaseLayer) {
    // Bij project niveau: altijd satellite (PDOK luchtfoto)
    // Bij alle andere niveaus: de door de gebruiker gekozen baseLayer (osm of satellite)
    const baseLayers = ['osm', 'satellite'];
    let effectiveBaseLayer = activeBaseLayer;
    if (level === 'project' && activeBaseLayer !== 'satellite') {
      effectiveBaseLayer = 'satellite';
    }

    map.getStyle().layers.forEach(layer => {
    if (layer.metadata) {
      if (layer.metadata.niveau.includes(level)) {
        if (baseLayers.includes(layer.id)) {
          map.setLayoutProperty(layer.id, 'visibility', effectiveBaseLayer === layer.id ? 'visible' : 'none');
        } else {
          map.setLayoutProperty(layer.id, 'visibility', 'visible');
        }
      } else {
        map.setLayoutProperty(layer.id, 'visibility', 'none');
    }
  }
  });
}

// Helper: capitalize first letter and replace spaces with underscores
function gemeenteSlug(naam) {
  if (!naam) return '';
  return naam.charAt(0).toUpperCase() + naam.slice(1).replace(/ /g, '_');
}

// Generate dynamic colors for regions
function generateRegioColors(regioNames) {
  const colors = [
    '#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00',
    '#ffff33', '#a65628', '#f781bf', '#1f78b4', '#33a02c',
    '#fb9a99', '#fdbf6f', '#cab2d6', '#6a3d9a', '#b15928',
    '#17becf', '#bcbd22', '#7f7f7f', '#e377c2', '#2ca02c'
  ];

  const colorExpression = ['case'];
  regioNames.forEach((regio, index) => {
    colorExpression.push(
      ['==', ['get', 'regio'], regio],
      colors[index % colors.length]
    );
  });
  colorExpression.push('#666666'); // fallback color

  return colorExpression;
}

export { toggleBasemap, gemeenteSlug, generateRegioColors };
